<template>
  <div class="content" data-toggle="appear">
      <div class="row">
        <!-- Row #1 -->
        <div class="col-6 col-xl-3">
            <admin-stats-calls-count />
        </div>
        <div class="col-6 col-xl-3">
            <admin-stats-departures-count />
        </div>
        <div class="col-6 col-xl-3">
            <admin-stats-payments-count />
        </div>
        <div class="col-6 col-xl-3">
            <admin-stats-online-users-count />
        </div>
        <!-- END Row #1 -->
      </div>
      <div class="row">
        <div class="col-md-9">
          <admin-payments-linechart />
          <admin-comments-linechart />
          <admin-debts-stats-doughnutchart />
        </div>
        <div class="col-md-3">
          <admin-online-users />
        </div>
      </div>
  </div>
</template>

<script>
export default {
  components: {
    AdminStatsCallsCount: () => import('@/components/admin/stats/blocks/callsCount.vue'),
    AdminStatsDeparturesCount: () => import('@/components/admin/stats/blocks/departuresCount.vue'),
    AdminStatsPaymentsCount: () => import('@/components/admin/stats/blocks/paymentsCount.vue'),
    AdminStatsOnlineUsersCount: () => import('@/components/admin/stats/blocks/onlineUsersCount.vue'),
    AdminOnlineUsers: () => import('@/components/admin/users/online.vue'),
    AdminPaymentsLinechart: () => import('@/components/admin/charts/lineChart/payments.vue'),
    AdminCommentsLinechart: () => import('@/components/admin/charts/lineChart/comments.vue'),
    AdminDebtsStatsDoughnutchart: () => import('@/components/admin/charts/doughnutChart/debtsStats.vue'),
  },
};
</script>
